import type { SolutionSector } from "../sectors";
import { ASK_LINE, CHECK_LINE, LOGO } from "./shared";

export const HOTELS: SolutionSector = {
  slug: "hotels",
  name: "Hotels",
  demoOrg: "Demo (Hotels)",
  story: "hotels",
  metadata: {
    title: "AI for hotel group operations reviews | Your Twin",
    description:
      "See open supplier queries, missing paperwork and owners across your properties. Your Twin connects SunSystems, Google Sheets, SharePoint and Outlook.",
  },
  hero: {
    label: "Hotels",
    title: ["Know what’s", "open at", "each property."],
    lead: [
      "Spend less time chasing property updates. Your Twin connects ",
      LOGO.sunsystems,
      " records with action trackers in ",
      LOGO.sheets,
      ", supplier documents in ",
      LOGO.sharepoint,
      " and updates in ",
      LOGO.outlook,
      ", so you can see open supplier queries, missing paperwork and owners before the group operations review.",
    ],
    cta: "Bring a group operations review",
    buyer: "For group operations directors, finance directors and regional general managers",
    instrumentLabel: "The group Twin · Property, action, supplier and owner",
    legendLines: [
      "Read SunSystems, Google Sheets, SharePoint and Outlook.",
      "Link each property action to its bills, documents and updates.",
      "Build one picture of each property’s open actions.",
      CHECK_LINE,
      "Have agents prepare the group review and flag missing paperwork.",
      "Save their work in shared channels: property action trackers and review tables.",
      ASK_LINE,
    ],
  },
  replay: {
    title: "Which actions are\nstill open this week?",
    lead: "Ask across SunSystems, SharePoint and Outlook. See each open item beside its property, amount and owner.",
  },
  outcomes: {
    title: "Every property’s actions\nin one review.",
    lead: "Group operations sees the open items at each property, with the evidence and owner beside them.",
    items: [
      { title: "Bring property actions together.", body: "Review each property’s open actions in one place.", show: "sources" },
      { title: "Find the paperwork gap.", body: "See which actions lack the agreed supporting records.", show: "status" },
      { title: "Keep local ownership visible.", body: "Bring each recorded owner into the group review.", show: "owners" },
    ],
  },
  start: { firstStep: "Choose the group operations review your team prepares today." },
  questions: [
    {
      q: "Does it connect to our property management system?",
      a: "Not yet. No hotel property management system is in the connector list today. We check your system with you before it is in scope.",
    },
    { q: "Can it report occupancy or revenue per available room?", a: "Not from this workflow. That needs suitable operational data and agreed, checked definitions." },
    { q: "Will it manage bookings or guest requests?", a: "No. This page covers group operations: supplier bills, paperwork and property actions." },
  ],
  closing: "Start with one\ngroup operations review.",
};
